import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductPickerNavigationService {
  public readonly isProductPicker$ = new BehaviorSubject<boolean>(undefined);

  public onOpenProductPicker(): void {
    this.isProductPicker$.next(true);
  }

  public onCloseProductPicker(): void {
    this.isProductPicker$.next(false);
  }
}
